import { render, staticRenderFns } from "./StDataTable.vue?vue&type=template&id=390c15fa&"
import script from "./StDataTable.vue?vue&type=script&lang=js&"
export * from "./StDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports